import { Route, Routes } from 'react-router-dom';

import KnowledgeLayout from '../components/knowledge/KnowledgeLayout.jsx';
import SubtabIndexRedirect from '../components/SubtabIndexRedirect.jsx';
import { DEFAULT_KNOWLEDGE_SUBTAB } from '../constants/knowledge.js';
import DrivePage from './DrivePage.jsx';
import SandboxPage from './SandboxPage.jsx';
import TruthPage from './TruthPage.jsx';

/**
 * The Knowledge tab of a profile (CT-5717): Drive, Sandbox and Truth as child
 * routes, under the shared switch and summary line of `KnowledgeLayout`. A tab
 * KIND (`TAB_KINDS.KNOWLEDGE`); the tabs endpoint decides who gets it.
 * Sandbox is CT-5718, Truth CT-5719.
 */
function KnowledgeTabPage() {
  return (
    <Routes>
      <Route element={<KnowledgeLayout />}>
        <Route index element={<SubtabIndexRedirect to={DEFAULT_KNOWLEDGE_SUBTAB} />} />
        <Route path="drive" element={<DrivePage />} />
        <Route path="sandbox" element={<SandboxPage />} />
        <Route path="truth" element={<TruthPage />} />
      </Route>
    </Routes>
  );
}

export default KnowledgeTabPage;
